import React from 'react';
import { GenericFormPage } from '../../components/generic';
import { useCatalogItem, CatalogItem } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';

const Form: React.FC = () => {
  return (
    <GenericFormPage<CatalogItem>
      useData={useCatalogItem}
      config={{
        ...moduleConfig,
        getInitialFormData: getInitialFormData as () => Partial<CatalogItem>,
        mapItemToFormData: mapItemToFormData as (item: CatalogItem) => Partial<CatalogItem>,
        renderEditFormExtra: moduleConfig.renderEditFormExtra,
      }}
    />
  );
};

export default Form;
